"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageFooter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../constants");
var _SettingsPageFooter = require("./SettingsPageFooter");
var _SystemCheckPageFooter = require("./SystemCheckPageFooter");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * PageFooter component renders the footer for the Join page.
 * @param currentPage
 * @param goToPage
 * @param checkStatus
 * @param errors
 * @param hasValidationError
 * @param hasAudioDevice
 * @param isStandaloneChecker
 * @param handleJoinMeeting
 * @param runSystemCheck
 * @param sourceLoadStatus
 * @param isJoinInProgress
 * @returns {JSX.Element|null}
 * @constructor
 */
var PageFooter = exports.PageFooter = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var currentPage = _ref.currentPage,
    goToPage = _ref.goToPage,
    checkStatus = _ref.checkStatus,
    errors = _ref.errors,
    hasValidationError = _ref.hasValidationError,
    hasAudioDevice = _ref.hasAudioDevice,
    isStandaloneChecker = _ref.isStandaloneChecker,
    handleJoinMeeting = _ref.handleJoinMeeting,
    runSystemCheck = _ref.runSystemCheck,
    sourceLoadStatus = _ref.sourceLoadStatus,
    isJoinInProgress = _ref.isJoinInProgress,
    userBackgroundLoading = _ref.userBackgroundLoading;
  if (currentPage === _constants.JOIN_PAGE.SETTINGS) {
    return /*#__PURE__*/_react["default"].createElement(_SettingsPageFooter.SettingsPageFooter, {
      userBackgroundLoading: userBackgroundLoading,
      goToPage: goToPage,
      checkStatus: checkStatus,
      errors: errors,
      hasValidationError: hasValidationError,
      hasAudioDevice: hasAudioDevice,
      isStandaloneChecker: isStandaloneChecker,
      handleJoinMeeting: handleJoinMeeting,
      sourceLoadStatus: sourceLoadStatus,
      isJoinInProgress: isJoinInProgress
    });
  }
  if (currentPage === _constants.JOIN_PAGE.SYSTEM_CHECK) {
    return /*#__PURE__*/_react["default"].createElement(_SystemCheckPageFooter.SystemCheckPageFooter, {
      userBackgroundLoading: userBackgroundLoading,
      checkStatus: checkStatus,
      isStandaloneChecker: isStandaloneChecker,
      errors: errors,
      goToPage: goToPage,
      runSystemCheck: runSystemCheck,
      handleJoinMeeting: handleJoinMeeting,
      isJoinInProgress: isJoinInProgress
    });
  }
  return null;
});
PageFooter.propTypes = {
  currentPage: _propTypes.string.isRequired,
  goToPage: _propTypes.func.isRequired,
  checkStatus: _propTypes.string.isRequired,
  errors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  hasValidationError: _propTypes.bool.isRequired,
  hasAudioDevice: _propTypes.bool.isRequired,
  isStandaloneChecker: _propTypes.bool.isRequired,
  handleJoinMeeting: _propTypes.func.isRequired,
  sourceLoadStatus: _propTypes.string,
  isJoinInProgress: _propTypes.bool
};